import type { RouteRecordRaw } from 'vue-router'

// Written-exam practice: hub (题库), a subject's chapters, the mode picker and the answering page of a server session.
// The four views replace the earlier /practice catalog and per-chapter pages.
export const routes: RouteRecordRaw[] = [
  { path: '/quiz', name: 'quiz-modes', component: () => import('./HubView.vue') },
  { path: '/practice', redirect: '/quiz' },
  { path: '/practice/session/:id', name: 'practice-play', component: () => import('./SessionView.vue'), props: true },
  { path: '/practice/:subject', name: 'practice-subject', component: () => import('./SubjectView.vue'), props: true },
  { path: '/practice/:subject/:chapter', name: 'practice-mode', component: () => import('./ModeView.vue'), props: true },
  { path: '/quiz/lesson/:subject/:chapter', name: 'quiz-lesson', component: () => import('./LessonView.vue'), props: true, meta: { title: '图解小课' } },
  ...[
    ['gallery', '图谱库'], ['visual', '看图懂考点'], ['topic', '专题辨析'], ['person', '人物关系'], ['extreme', '之最辨析'], ['delta', '新纲变动'],
  ].map(([id, title]): RouteRecordRaw => ({ path: `/quiz/special/${id}`, name: `quiz-special-${id}`, component: () => import('../../views/SpecialView.vue'), meta: { title } })),
]
